import { Column, Button } from 'components/Blocks';

import warning from 'assets/animations/warning.json';
import { SVGAnimation } from 'components/SVGAnimation';
import { DownloadIcon } from 'components/Icons';

import { actions } from 'entities';

interface DownloadNewProps {
  children?: never;
  code: string;
}

function DownloadNew({ code }: DownloadNewProps): JSX.Element {
  const downloadPDF = actions.projects.downloadPDFByCode.use({
    params: { code },
  });

  return (
    <Column alignItems="center">
      <SVGAnimation size={144} animationData={warning} />

      <h4 className="text-warning-light">Warning!</h4>

      <p>There has been some changes to this project information.</p>

      <p>Please download the up to date version below.</p>

      <Button {...downloadPDF.buttonProps}>
        <DownloadIcon size={16} />
        Download
      </Button>
    </Column>
  );
}

export default DownloadNew;
